import { render, staticRenderFns } from "./MyCodeListButtonRadio.vue?vue&type=template&id=21676401&scoped=true&"
import script from "./MyCodeListButtonRadio.vue?vue&type=script&lang=js&"
export * from "./MyCodeListButtonRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21676401",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21676401')) {
      api.createRecord('21676401', component.options)
    } else {
      api.reload('21676401', component.options)
    }
    module.hot.accept("./MyCodeListButtonRadio.vue?vue&type=template&id=21676401&scoped=true&", function () {
      api.rerender('21676401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyCodeListButtonRadio.vue"
export default component.exports